<template>
  <div class="black-list-container">
    <div class="search-content">
      <el-input v-model="name" :placeholder="$t('carPatrolBlack.placeholder.nameFilter')" clearable @keyup.enter.native="getBlackList">
        <i slot="prefix" class="el-input__icon el-icon-search search-group-name" @click="getBlackList" style="cursor: pointer"></i>
      </el-input>
    </div>
    <!-- 自定义名单树 -->
    <div class="list-content sbar">
      <el-scrollbar style="height:100%;">
      <div class="list-item" v-for="(items, indexs) in blackListData" :key="indexs">
        <div class="title" style="position:relative;" @click="listTitleClick(indexs)">
          <i class="el-icon-caret-bottom"></i>&nbsp;&nbsp;{{items.plateCode}}
          <div style="changeStyle">
            <div @click="addGroup(items, indexs)" v-auth="'/carPatrolBlack:addGroup'" class="iconStyle el-icon-plus">
            </div>
          </div>
        </div>
        <ul class="show">
          <li style="position:relative;" v-for="(item, index) in items.children" :key="index" :class="(indexs === nowIndex.parentIndex && index === nowIndex.childrenIndex) ? 'active list-text' : 'list-text'" @click="listItemClick(item, indexs, index)">
            <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
              <span class="list-name">{{item.name|ellipsis(32)}}</span>
            </el-tooltip>
            <span style="position:absolute;right:33px;" class="iconStyle el-icon-edit" @click="listUpdateClick(item)"></span>
            <span style="position:absolute;right:10px;" class="iconStyle el-icon-delete" @click="deleteclick"></span>
          </li>
        </ul>
      </div>
      </el-scrollbar>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog
      :title="state === 1 ? this.$t('carPatrolBlack.title.addBlack') : this.$t('carPatrolBlack.title.editBlack')"
      :visible.sync="formShow"
      v-dialogDrag
      :close-on-click-modal="false"
      v-ops:width="680"
      @close="formClose">
      <ioc-form :option="formOption" v-model="formData" ref="form"></ioc-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addBackList" v-text="$t('carPatrolBlack.button.save')"></el-button>
        <el-button @click="formClose">{{$t('carPatrolBlack.button.cancel')}}</el-button>
      </span>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      :title="$t('carPatrolBlack.title.nameList')"
      :visible.sync="detailShow"
      v-dialogDrag
      v-ops:width="680"
      :close-on-click-modal="false"
      >
      <ioc-form :option="detailOption" v-model="detailData"></ioc-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Close" v-text="$t('carPatrolBlack.button.close')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { API } from "../api";
import { Dic } from '$utils'
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, '');
}

const textCheck = (rule, value, callback) => {
  const str = trim(value)
  if (str.length === 0) {
    callback(new Error("请输入黑名单组名称"))
  } else if (str[0] === '.' || str[0] === '·' || str[0] === '-') {
    callback(new Error("允许中文、字母、数字、空格、'·'、'.'、'-'，且首不能为'·'、'.'、'-'"))
  } else {
    const reg = /^[\u4e00-\u9fa5a-zA-Z0-9. ·-]*[\u4e00-\u9fa5a-zA-Z0-9. ·-]$/
    if (!reg.test(str)) {
      callback(new Error("允许中文、字母、数字、空格、'·'、'.'、'-'，且首不能为'·'、'.'、'-'"))
    } else {
      callback()
    }
  }
}
export default {
  data () {
    return {
      nowIndex: {
        parentIndex: 0,
        childrenIndex: 0
      },
      detailShow: false,
      nowCode: {}, // 当前名单组数据
      formShow: false,
      repositorCode: '', // 库ID
      state: 1, // 1: 新增 2：修改
      groupType: 0, // 0:黑名单 1：白名单
      // 表单配置项
      formOption: {
        labelWidth: 120,
        emptyBtn: false,
        submitBtn: false,
        column: [{
          label: this.$t('carPatrolBlack.label.blackName'),
          span: 24,
          prop: 'name',
          maxlength: 30,
          rules: [
            { required: true, message: this.$t('carPatrolBlack.placeholder.blackName'), trigger: 'blur'},
            { validator: textCheck, trigger: 'blur'}
          ],
          placeholder: this.$t('carPatrolBlack.placeholder.blackName')
        }, {
          label: this.$t('carPatrolBlack.label.describe'),
          span: 24,
          prop: 'desc',
          type: 'textarea',
          maxlength: 255,
          placeholder: this.$t('carPatrolBlack.placeholder.describe')
        }]
      },
      // 详情配置项
      detailOption: {
        labelWidth: 110,
        emptyBtn: false,
        submitBtn: false,
        column: [{
          label: this.$t('carPatrolBlack.label.blackName'),
          span: 24,
          disabled: true,
          prop: 'name',
        }, {
          label: this.$t('carPatrolBlack.label.describe'),
          span: 24,
          disabled: true,
          prop: 'desc',
          type: 'textarea',
          placeholder: ' '
        }]
      },
      // 表单数据
      formData: {
        name: '',
        desc: ''
      },
      // 详情数据
      detailData: {
        name: '',
        desc: ''
      },
      name: '',
      blackListData: [],
      defaultProps: {
        children: 'children',
        label: 'plateCode'
      }
    }
  },
  watch: {
    name (val) {
      if (val.length) {
          return false
      }
      this.getBlackList()
    },
    nowCode: {
      handler(val, oldVal){
        console.log(this.blackListData, 'this.blackListData2')
        if (val.type === 0) {
          this.groupType = val.type;
          this.$parent.formList = this.blackListData[0].children
        } else if (val.type === 1) {
          this.groupType = val.type;
          this.$parent.formList = this.blackListData[1].children
        }
        this.$emit('queryBackList', val)
        // if (val && val.code) {
        //   this.$emit('queryBackList', val.code)
        // }
      },
      deep:true
    },
    blackListData: {
      handler(newValue, oldValue) {
        // this.$parent.formList = newValue[0].children
        if (this.nowCode.type === 0) {
          this.$parent.formList = newValue[0].children
        } else if (this.nowCode.type === 1) {
          this.$parent.formList = newValue[1].children
        }
      },
      deep: true
    }
  },
  mounted () {
    this.getBlackList();
    this.queryCarType();
  },
  methods: {
    formClose () {
      this.formShow = false
      this.formData = {
        name: '',
        desc: ''
      }
      this.$refs['form'].clearValidate()
    },
    // 名单修改
    listUpdateClick (item) {
      console.log('item',item)
      if (!this.nowCode) {
        this.$message.warning(this.$t('carPatrolBlack.message.choseGroup'))
        return false
      }
      this.state = 2
      this.formData = {
        name: item.name,
        desc: item.desc
      }
      this.formShow = true
    },
    // 详情
    detailClick () {
      if (!this.nowCode) {
        this.$message.warning(this.$t('carPatrolBlack.message.choseGroup'))
        return false
      }
      this.detailData = {
        name: this.nowCode.name,
        desc: this.nowCode.desc
      }
      this.detailShow = true
    },
    // 删除
    deleteclick () {
      if (!this.nowCode) {
        this.$message.warning(this.$t('carPatrolBlack.message.choseGroup'))
        return false
      }
      this.$confirm(this.$t('carPatrolBlack.message.deleteList'), this.$t('carPatrolBlack.title.remind'), {
        confirmButtonText: this.$t('carPatrolBlack.button.confirm'),
        cancelButtonText: this.$t('carPatrolBlack.button.cancel'),
        type: 'warning'
      }).then(() => {
        this.$fetch(API.group.deleteVehicleGroup, {
          code: this.nowCode.code
        }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('carPatrolBlack.message.deleteOk'));
            this.nowIndex = {
              parentIndex: 0,
              childrenIndex: 0
            };
            this.getBlackList();
          } else {
            this.$message.error(this.$t('carPatrolBlack.message.deleteNo') + res.msgContent)
          }
        })
      })
    },
    addGroup(data, ind) {
      console.log(data);
      this.state = 1;
      this.groupType = data.type;
      this.formShow = true;
      this.nowIndex.parentIndex = ind;
    },
    // 新增/修改名单组
    addBackList () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let url = this.state === 1 ? API.group.addVehicleGroup : API.group.updateGroup
          let params = {}
          if (this.state === 1) {
            params = {
              name: trim(this.formData.name),
              type: this.groupType,
              desc: this.formData.desc
            }
          } else {
            params = {
              name: trim(this.formData.name),
              desc: this.formData.desc,
              type: this.groupType,
              repositorCode: this.nowCode.code
            }
          }
          this.$fetch(url, params).then(res => {
            if (res.success) {
              this.$message.success(this.state === 1 ? this.$t('carPatrolBlack.title.addOk') : this.$t('carPatrolBlack.title.editOk'))
              this.formShow = false
              this.getBlackList();
              this.listTitleClick (this.nowIndex.parentIndex);
            } else {
              this.$message.error(res.msgContent)
            }
          })
        } else {
          return false
        }
      })
    },
    // 请求名单组bwListGroupQryVo
    getBlackList () {
      const params = {
          name: this.name
      }
      this.$fetch(API.group.queryVehicleGroup, params).then(res => {
        const result = res.returnObj;
        if (result && result.list) {
          // debugger
          this.blackListData.forEach(item => {
            item.children.length = 0
          })
          if (res.returnObj.list.length === 0) {
            $('.show .list-text').remove()
          }
          res.returnObj.list.map(item => {
            if (item.type === 0) {
              this.blackListData[0].children.push(item)
            } else if (item.type === 1) {
              this.blackListData[1].children.push(item)
            } else if (item.type === 2) {
              this.blackListData[2].children.push(item)
            }
          })
          if (this.blackListData[0].children[0]) {
            this.nowCode = this.blackListData[0].children[0]
            this.nowIndex = {
              parentIndex: 0,
              childrenIndex: 0
            }
          } else if (this.blackListData[1].children[0]) {
            this.nowCode = this.blackListData[1].children[0]
            this.nowIndex = {
              parentIndex: 1,
              childrenIndex: 0
            }
          }  else if (this.blackListData[2].children[0]) {
            this.nowCode = this.blackListData[2].children[0]
            this.nowIndex = {
              parentIndex: 2,
              childrenIndex: 0
            }
          } else {
            this.nowCode = {
              type: -1
            }
          }
        }
      })
    },
    // 名单组点击回调
    listItemClick (data, indexs, index) {
      this.nowIndex = {
        parentIndex: indexs,
        childrenIndex: index
      }
      this.nowCode = data
    },
    // 名单组标题点击事件
    listTitleClick (indexs) {
      let dom = $('.black-list-container .list-content .list-item .title')[indexs]
      $(dom).children('i')[0].className === 'el-icon-caret-bottom' ? $(dom).children('i')[0].className = 'el-icon-caret-right' :  $(dom).children('i')[0].className = 'el-icon-caret-bottom'
      $(dom).next()[0].className === 'show' ? $(dom).next()[0].className = 'hide' :  $(dom).next()[0].className = 'show'
    },
    Close(){
        this.detailShow = false
    },
    queryCarType(){
      Dic.find('SENU061').map((item, ind) => {
        this.blackListData.push({
          plateCode: item.label,
          type: item.value,
          isParent: true,
          children: []
        })
      })
    }
  }
}
</script>
<style>
.iconStyle{
  position:absolute;
  right:10px;
  top:25%;
  padding:1px 2px 1px 2px;
  /* background:#383f6e; */
}
</style>
